import React, {useEffect, useState} from 'react';

import Strings from '../../constants/stringConstant';
import Path from '../../constants/path';
import NameCard from '../../components/NameCard/nameCard';
// import {getUserData} from '../../utils/appUtils';
import {useDispatch, useSelector} from 'react-redux';
import makeApiCall from '../../api/makeApiCall';
import {setLoanPayLoadValue} from '../../state/slice/loanListPayloadSlice';
import DashboardComponent from '../../components/Dashboard/dashboard';
import {toast} from 'react-toastify';
import {fetchEmployeeName} from '../../api/request/manageReassignApi/manageReassignApi';
import SingleFilter from './SingleFilter';
import {useTranslation} from 'react-i18next';
import {fetchBranchTagDetail} from '../../api/request/apilogApis/apilogApi';

const ManageReassignment = () => {
  // const userData = getUserData();
  const {t: translator} = useTranslation();
  const [filterSelected, setFilterSelected] = useState([]);
  const {roleBased} = useSelector(state => state.rbacValue);
  console.log(roleBased, 'roleBased');

  const handleFilterChange = updatedFilters => {
    setFilterSelected(updatedFilters);
    dispatch(setLoanPayLoadValue({currentPage: 1}));
    fetchPaginationData(1, updatedFilters);
  };
  const paths = [
    {
      name: Strings.manageReassignement.manageReassignementHeader,
      link: Path.manage_reassign,
    },
  ];
  const dispatch = useDispatch();
  const {currentPage, searchQuery} = useSelector(
    state => state.loanListPayload,
  );
  useEffect(() => {
    dispatch(setLoanPayLoadValue({applicationType: 'Manage Reassignment'}));
    fetchBranchData();
  }, []);

  const [cards, setCards] = useState([]);

  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const cardsPerPage = 15;
  const [totalCount, setTotalCount] = useState('');
  const [branchListVal, setBranchListVal] = useState([]);
  const handleApiError = response => {
    let errorCode = response?.data?.error?.errorCode;
    let errorMessage = translator(`ErrorMessages.${errorCode}`);

    if (!errorCode || errorMessage === `ErrorMessages.${errorCode}`) {
      errorCode = 'SAMASTA001';
      errorMessage = translator('ErrorMessages.SAMASTA001');
    }
    if (
      response?.data?.error?.errorCode !== 'SAMASTA015' &&
      response?.data?.error?.errorCode !== 'SAMASTA013'
    ) {
      toast.error(errorMessage);
    }
  };
  const fetchBranchData = async () => {
    try {
      const response = await makeApiCall(fetchBranchTagDetail());

      if (response.data.status === Strings.success) {
        console.log(response?.data, 'data');

        setBranchListVal(response.data.data);
      } else {
        setBranchListVal([]);
        if (response.data.status === Strings.error) {
          handleApiError(response);
        }
      }
    } catch (error) {
      toast.error(Strings.apiError, {
        position: 'top-right',
      });
    }
  };
  const fetchPaginationData = async (
    pageNumber = currentPage,
    branchFilter = filterSelected,
  ) => {
    setLoading(true);
    try {
      const payload = {
        branchId: branchFilter,
        pageNumber: pageNumber - 1,
        pageSize: 15,
        searchTerm: searchQuery,
        role: 'SO',
      };
      const response = await makeApiCall(fetchEmployeeName(payload));

      if (response.data.status === Strings.success) {
        setLoading(false);
        const responseValue = response.data.data;
        setCards(responseValue?.content);
        setTotalCount(responseValue?.totalElements);
        setTotalPages(Math.ceil(responseValue?.totalElements / cardsPerPage));
      } else {
        setLoading(false);
        if (response.data.status === Strings.error) {
          if (
            response?.data?.error?.errorCode === 'SAMASTA015' ||
            response?.data?.error?.errorCode === 'SAMASTA013'
          ) {
            setTotalPages(0);
            setTotalCount(0);
          }
          setCards([]);
        }
      }
    } catch (error) {
      setLoading(false);
      toast.error(Strings.apiError, {
        position: 'top-right',
      });
      setCards([]);
      setTotalPages(0);
      console.log('failed:', error);
    }
  };

  const handlePageChange = (event, value) => {
    dispatch(setLoanPayLoadValue({currentPage: value}));
    fetchPaginationData(value);
  };

  const handleSearch = query => {
    dispatch(setLoanPayLoadValue({searchQuery: query, currentPage: 1}));
  };
  return (
    <DashboardComponent
      paths={paths}
      searchQuery={searchQuery}
      onSearch={handleSearch}
      cards={cards}
      fetchData={fetchPaginationData}
      CardComponent={NameCard}
      totalCount={totalCount}
      loading={loading}
      totalPages={totalPages}
      currentPage={currentPage}
      handlePageChange={handlePageChange}
      dashboardType={Strings.manageReassignement.manageReassignementHeader}
      countValue={'Records'}
      filter={
        <>
          {' '}
          <SingleFilter
            filterType={'branch'}
            buttonName={'Branch'}
            filterName={'branch'}
            filterKey={'branchCode'}
            options={branchListVal}
            filterSelected={filterSelected}
            onFilterChange={handleFilterChange}
          />
        </>
      }
    />
  );
};

export default ManageReassignment;
